"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultConfig = void 0;
const date_inputs_1 = require("@kyruus/date-inputs");
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const read_only_1 = __importDefault(require("../../read-only"));
const use_form_1 = __importDefault(require("../../../form/use-form"));
const DOBInput = ({ path }) => {
    const [{ value, errors, config: { label, isReadOnly, isVisible, isRequired, month, day, year }, AddOn }, { onChange, onBlur }] = (0, use_form_1.default)(path, {
        eventProcessor: (dob) => dob
    });
    const MONTH_INPUT = 'MONTH';
    const DAY_INPUT = 'DAY';
    const YEAR_INPUT = 'YEAR';
    if (!isVisible) {
        return null;
    }
    if (isReadOnly) {
        return react_1.default.createElement(read_only_1.default, { msg: value });
    }
    /**
     * This will fire on the initial render and will set the config.initialValue
     * appropriately when the component is initialized with a value by the form
     * @param {String} inputType One of MONTH, DAY, YEAR
     * @returns {Object} The individual date input configs objects (e.g. config.month)
     */
    const getInitialConfig = (inputType) => {
        const valueStringParts = getValueStringParts();
        switch (inputType) {
            case MONTH_INPUT:
                if (valueStringParts.month !== '') {
                    return Object.assign(Object.assign({}, month), { initialValue: valueStringParts.month });
                }
                return month;
            case DAY_INPUT:
                if (valueStringParts.day !== '') {
                    return Object.assign(Object.assign({}, day), { initialValue: valueStringParts.day });
                }
                return day;
            case YEAR_INPUT:
                if (valueStringParts.year !== '') {
                    return Object.assign(Object.assign({}, year), { initialValue: valueStringParts.year });
                }
                return year;
        }
    };
    /**
     * Splits the value up into its individual parts. Assumes the date is
     * of the format YYYY-MM-DD. If it fails, it returns an object with empty
     * string for each of the month, day and year keys.
     * @returns {Object} The individual string parts (e.g. {month: '06',..})
     */
    const getValueStringParts = () => {
        try {
            const parts = value.split('-');
            return { month: parts[1], day: parts[2], year: parts[0] };
        }
        catch (e) {
            return { month: '', day: '', year: '' };
        }
    };
    /**
     * The onChange handler thats passed to the date input component
     * @param {Object} data The data object passed by the date input component to the callback
     */
    const onChangeWrapper = (data) => {
        let value;
        const values = [data.year, data.month, data.day];
        if (data.date) {
            // date is valid
            value = values.join('-');
        }
        else if (values.filter(Boolean).length === 0) {
            // set value to empty since all inputs are cleared
            value = '';
        }
        else {
            // Error will get caught by dob validator
            value = new Error('invalid dob');
        }
        onChange(value);
        // only run validation when all values are entered
        if (data.year && data.month && data.day && data.year.length === 4) {
            onBlur(value);
        }
    };
    return (react_1.default.createElement(react_1.Fragment, null,
        react_1.default.createElement("div", null,
            react_1.default.createElement(date_inputs_1.SeparateNumericsDateInput, { label: label, hideLabel: true, required: isRequired, month: Object.assign(Object.assign({}, getInitialConfig(MONTH_INPUT)), { autoComplete: 'bday-month' }), day: Object.assign(Object.assign({}, getInitialConfig(DAY_INPUT)), { autoComplete: 'bday-day' }), year: Object.assign(Object.assign({}, getInitialConfig(YEAR_INPUT)), { autoComplete: 'bday-year' }), errors: errors, onChange: onChangeWrapper })),
        react_1.default.createElement(AddOn, null)));
};
DOBInput.propTypes = {
    path: prop_types_1.default.string.isRequired
};
exports.default = DOBInput;
exports.defaultConfig = {
    month: { placeholder: 'MM' },
    day: { placeholder: 'DD' },
    year: { placeholder: 'YYYY' }
};
//# sourceMappingURL=index.js.map